module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Copyright © 2025 by Dr. Beth Kaplan, Ed.D.")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Published by Mango Publishing, a division of Mango Publishing Group, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cover Design: Elina Diaz")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Cover Photo/illustration: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://stock.adobe.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("stock.adobe.com/")])])]), _vm._v(" kappacha, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://stock.adobe.com/249",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("stock.adobe.com/249")])])]), _vm._v(" Anurak Layout & Design: Elina Diaz")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Research, interviews, and information were sourced from the author’s dissertation: Beth Kaplan Kondonijakos, “A Social Constructivist Approach to Understanding Belonging in the Workplace.” University of Pennsylvania, 2021, and the Belonging at WorkTM article series.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open society.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s rights.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("For permission requests, please contact the publisher at:")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Mango Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("5966 South Dixie Highway, Suite 300")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Miami, FL 33143")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("info@mango.bz")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("sales@mango.bz")])])]), _vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("customer.service@ingramcontent.com")])])]), _vm._v(" or +1.800.509.4887.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Braving the Workplace: Belonging at the Breaking Point")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication number: 2024943931")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("ISBN: (print) 978-1-68481-695-8, (ebook) 978-1-68481-696-5")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("BISAC category code: BUS118000, BUSINESS & ECONOMICS / Diversity & Inclusion "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://drbethkaplan.com/home/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://drbethkaplan.com/home/")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbd538e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Copyright.vue
// module id = 66
// module chunks = 0